/* eslint-disable */

import React, { useEffect, useState } from "react";
import { setLanguage } from "./../helpers/language-helper";
import { Tabs, Button, message, notification } from "antd";
import Banner from "../components/Banner";
import * as API from "../config/apiConfig";
import { userAwbLogout } from "../actions/userAWB";
import "./page-css/Agent.css";
import ChangePasswordTab from "../components/ChangePasswordTab";
import { useDispatch, useSelector } from "react-redux";
import TabVIPInboundShippment from "../components/VIPUser/TabVIPInboundShippment";
import TabReportForOutboundShipment from "../components/VIPUser/TabReportForOutboundShipment";
import TabInfo from "../components/TabInfo";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { changeLang, showLangSwitch } from "../actions/menu";
import { setMAWB } from "../actions/MAWB";

const { TabPane } = Tabs;
const VIP = () => {
    const history = useHistory();
    const token = JSON.parse(localStorage.getItem("userAWB"));
    const { dataLogin } = useSelector((state) => state.userAwb);
    const [activeKey, setActiveKey] = useState("import-info");
    const dispatch = useDispatch();
    const { t } = useTranslation("common");
    const today = new Date(),
        date =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate() +
            " " +
            today.getHours() +
            ":" +
            today.getMinutes();

    const logOut = () => {
        API.logout(token).then((res) => {
            dispatch(userAwbLogout());
            dispatch(setMAWB({}));
            localStorage.removeItem("userAWB");
            localStorage.removeItem("MAWB");
            message.success(res.data.message);
            history.push("/");
        });
    };
    const operations = (
        <Button
            className="logout-btn"
            onClick={logOut}
            style={{ width: "fit-content" }}
        >
            {t("header.logOut")}
        </Button>
    );

    useEffect(() => {
        if (dataLogin.data.user_code !== "ad") {
            notification.warning({
                message: "Tài khoản này không có quyền truy cập!",
                style: { marginRight: "-50%" },
            });
            history.push("/");
        }
        dispatch(changeLang("1"));
        setLanguage("en");
        localStorage.setItem("langId", "1");
        dispatch(showLangSwitch(false));
        return () => {
            dispatch(changeLang("2"));
            setLanguage("vi");
            localStorage.setItem("langId", "2");
        };
    }, []);

    return (
        <div className="agent-wrapper">
            <Banner
                title={""}
                className="banner-wrapper"
                cover={"../../img/004.jpg"}
            />
            <div className="agent-content-wrapper">
                <div style={{ padding: "0px 10%" }} className="agent-content">
                    <Tabs
                        tabBarExtraContent={operations}
                        tabBarGutter={15}
                        activeKey={activeKey}
                        onChange={(key) => {
                            setActiveKey(key);
                        }}
                        size={"default"}
                    >
                        <TabPane
                            className="awb-tab-content-wrapper"
                            tab={t("header.exportInfo")}
                            key={"import-info"}
                        >
                            <TabInfo />
                        </TabPane>
                        <TabPane
                            className="awb-tab-content-wrapper"
                            tab={"Report for Inbound Shippment"}
                            key={"report"}
                        >
                            <TabVIPInboundShippment setActiveKey={setActiveKey} />
                        </TabPane>
                        <TabPane
                            className="awb-tab-content-wrapper"
                            tab="Report For Outbound Shipment"
                            key={"schedule"}
                        >
                            <TabReportForOutboundShipment />
                        </TabPane>
                        {/* <TabPane
							className="awb-tab-content-wrapper"
							tab={t('header.registryInventory')}
							key={'registry-inventory'}
						>
							<TabRegistryInventory today={today} />
						</TabPane> */}
                        <TabPane
                            className="awb-tab-content-wrapper"
                            tab={t("header.changePass")}
                            key={"changePass"}
                        >
                            <ChangePasswordTab />
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        </div>
    );
};

export default VIP;
